export const userListSx = {
  overflow: 'auto',
  width: '100%',
  maxWidth: '100%',
  flex: 1,
  minHeight: 0,
  maxHeight: '100%',
} as const;
